<template>
  <v-app-bar
    app
    fixed
    elevation="1"
    color="white"
    light
    :hide-on-scroll="!mobile"
  >
    <app-drawer v-if="mobile"></app-drawer>

    <v-spacer v-if="mobile"></v-spacer>

    <div
      class="d-flex align-center"
      @click="$router.push({ name: 'Home' })"
    >
      <v-img
        height="40"
        width="40"
        contain
        :src="require('@/assets/img/logo.png')"
      ></v-img>
      <h4 class="ml-2 text-no-wrap">社團法人中華服務品質發展協會</h4>
    </div>

    <v-spacer></v-spacer>

    <div v-if="!mobile">
      <v-tabs slider-size="3">
        <template v-for="(router, idx) in routers">
          <v-tab
            :key="idx"
            :exact="idx===0"
            :to="router.to"
            class="font-weight-black"
            v-show="!router.disabled"
            :disabled="router.disabled"
          >{{ router.title }}</v-tab>
        </template>
      </v-tabs>
    </div>
  </v-app-bar>
</template>

<script>
export default {
  components: {
    'app-drawer': () => import('@/components/app/drawer')
  },
  computed: {
    mobile() {
      return this.$store.state.mobile;
    },
    routers() {
      return this.$store.state.routers;
    }
  }
}
</script>